import { createSlice } from "@reduxjs/toolkit";
import { AREA_UNITS, DEFAULT_AREA_UNIT } from "../utils/areaUnits";

const AREA_UNIT_KEY = "areaUnit";

const getStoredAreaUnit = () => {
  try {
    const stored = localStorage.getItem(AREA_UNIT_KEY);
    if (AREA_UNITS.some((unit) => unit.value === stored)) return stored;
  } catch {
    // storage unavailable
  }
  return DEFAULT_AREA_UNIT;
};

const settingsSlice = createSlice({
  name: "settings",
  initialState: { areaUnit: getStoredAreaUnit() },
  reducers: {
    setAreaUnit: (state, action) => {
      state.areaUnit = action.payload;
      try {
        localStorage.setItem(AREA_UNIT_KEY, action.payload);
      } catch {
        // storage unavailable; the choice lasts until reload
      }
    },
  },
});

export const { setAreaUnit } = settingsSlice.actions;
export default settingsSlice.reducer;
